// extracted by mini-css-extract-plugin
export default {"overlay":"CRTOverlay_overlay__TYo5-","crt-flicker":"CRTOverlay_crt-flicker__LPgLo","crt-scanline-drift":"CRTOverlay_crt-scanline-drift__iIgK3"};